import config from '../../../application/config/config';
import { Button } from 'react-bootstrap';
import Fetch from '../../../core/util/core/Fetch';
import Toast from '../../../core/components/core/Util/Toast/Toast';
import { useEffect, useState } from 'react';
import './RecalculateIpca.css';
import { getUserSession } from '../../../core/util/core/Session';

let intervalId = false;
function IpcaRecalculate(){

    const [disabledButton, setDisabledButton] = useState(false);
    const [textButton, setButtonText] = useState('Recalcular');
    const session = getUserSession();
    
    const teste = async () =>{
        const response = await Fetch.post(config.endpoints.backend + 'governanceroom/filefinbrarecalculateipca/save', {status: 'WAITING',  core_application_instance_id: session.user.application_instance_id})
        if(response.status !== 0){
          setDisabledButton(true);
          setButtonText('Recalculando...');
          createIntervalQuery();
        }else{
            Toast.error('Ocorreu um erro ao atualizar o valor do ipca.');
        }
    }

    const createIntervalQuery = () => {
      intervalId = setInterval(async () => {
        const response = await Fetch.post(config.endpoints.backend + 'governanceroom/filefinbrarecalculateipca/getByApplicationId', {core_application_instance_id: session.user.application_instance_id});
        setStatus(response);
      }, 5000);
      console.log(intervalId)
    }

    const setStatus = async(info) => {
      switch (info.status) {          
        case 'PROCESSING':
          setDisabledButton(true);
          setButtonText('Recalculando...');  
          break;
        case 'DONE':
          setDisabledButton(false);
          setButtonText('Recalcular');  
          Toast.success('Valor ipca atualizado com sucesso!');  
          if(intervalId !== false){
            clearInterval(intervalId);
          }    
          break;
        case 'ERROR':
          setDisabledButton(false);
          setButtonText('Recalcular');  
          Toast.error('Erro ao atualizar o valor do ipca!');  
          if(intervalId !== false){
            clearInterval(intervalId);
          }          
          break;
        default:
          break;
      }
    }

    useEffect(() => {
      async function fetchIpca() {
        const response = await Fetch.post(config.endpoints.backend + 'governanceroom/filefinbrarecalculateipca/getByApplicationId', {core_application_instance_id: session.user.application_instance_id});

        if(response.status !== 'DONE'){
          setStatus(response);
          createIntervalQuery();
        }
      }

      fetchIpca();
      return () => {
        if(intervalId !== false){
          clearInterval(intervalId);
        }
      };
    },[])

    return (
        <>
        <section className="content" style={{ marginTop: '30px' }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* /.card */}
                <div className="card card-outline card-info">
                  <div className="card-header">
                    <h3 className="card-title"><i className="fa-solid fa-pen-to-square mr-1"></i>Recalcular IPCA</h3>
  
                  </div>
                  {/* /.card-header */}
                  <div className='ml-3 mt-5 mb-5'>
                    <p>Esta tela possui a única função de recalcular o valor do IPCA sobre os valores informados na importação de arquivos Finbra, para realizar tal ação basta clicar no botão abaixo.</p>
                    <Button style={{width:'auto'}} onClick={() => teste()} disabled={disabledButton}>{textButton}</Button>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
      </>
    );
}

export default IpcaRecalculate;